/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuprSendJwtTokenResponse
 */
export interface SuprSendJwtTokenResponse {
    /**
     * Generated JWT token
     */
    token: string;
    /**
     * Token expiration timestamp
     */
    expires_at: number;
}

/**
 * Check if a given object implements the SuprSendJwtTokenResponse interface.
 */
export function instanceOfSuprSendJwtTokenResponse(value: object): value is SuprSendJwtTokenResponse {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined) return false;
    return true;
}

export function SuprSendJwtTokenResponseFromJSON(json: any): SuprSendJwtTokenResponse {
    return SuprSendJwtTokenResponseFromJSONTyped(json, false);
}

export function SuprSendJwtTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuprSendJwtTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'expires_at': json['expires_at'],
    };
}

export function SuprSendJwtTokenResponseToJSON(json: any): SuprSendJwtTokenResponse {
    return SuprSendJwtTokenResponseToJSONTyped(json, false);
}

export function SuprSendJwtTokenResponseToJSONTyped(value?: SuprSendJwtTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'expires_at': value['expires_at'],
    };
}

